import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class AiSettingRepositoryService extends BaseRepositoryService<
  ModelRegistry['ai-setting']
> {
  recordName = 'ai-setting';
  implementMethods = ['findAll', 'save'];

  resolveAutoReplyForProperty(propertyId: string | null): boolean {
    const settings = this.store.peekAll('ai-setting');

    const accountSetting = settings.find(
      (s: ModelRegistry['ai-setting']) => !s.isPropertyOverride,
    );
    const propertyOverride = propertyId
      ? settings.find(
          (s: ModelRegistry['ai-setting']) =>
            s.belongsTo('property').id() === propertyId,
        )
      : undefined;

    return (
      propertyOverride?.autoReplyEnabled ??
      accountSetting?.autoReplyEnabled ??
      false
    );
  }
}

declare module '@ember/service' {
  interface Registry {
    'repositories/ai-setting': AiSettingRepositoryService;
  }
}
